// @ts-nocheck
import Styleguide from "@toolkit/Framework/Types/Styleguide";

const icon: Styleguide["icon"] = {
    /* Store Custom Code - Start */
    defaultProps: {
        size: 18,
    },
    /* Store Custom Code - End */
};

export default icon;
